// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f86e30f9","884":"add81748","977":"c5f04fbb"}[chunkId] + ".chunk.js";
};